// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-checkpoint-edit-checkpoint-conditions-tab {
  display: block;
}
.fi-checkpoint-edit-checkpoint-conditions-tab .buttons-container.no-margin {
  margin-top: 0;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/checklist/fi-checklist2-edit/checkpoints-section-edit/checkpoint-edit/conditions-tab/conditions-tab.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;AACJ;AACI;EACI,aAAA;AACR","sourcesContent":[".fi-checkpoint-edit-checkpoint-conditions-tab {\r\n    display: block;\r\n\r\n    .buttons-container.no-margin {\r\n        margin-top: 0;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
